// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2lTEW","tab":"ProcedureTabs_tab__fFvVl"};